import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link } from 'react-router-dom';
import vAdminformat from "../../adminFormat";
import validateError from "../../ValidateError"

const server_backend = config.API_URL;

function UpdateUser({ username, onUserID, onClose, getUsers }) {
    const [loading, setLoading] = useState(false);
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");
    const [BranchList, setBranchList] = useState([]);
    const [GroupList, setGroupList] = useState([]);
    const [CurrentUserGroups, setCurrentUserGroups] = useState([]);

    const [checkedGroups, setCheckedGroups] = useState([]);
    const [addedGroups, setAddedGroups] = useState([]);
    const [removedGroups, setRemovedGroups] = useState([]);
    const [errors, setErrors] = useState({}); //To handle validation errors

    const [formData, setFormData] = useState({
        name: "",
        lastname: "",
        email: "",
        phone: "",
        dni: "",
        designation: "",
        department: "",
        suc_id: "",
        comment: "",
        lock: "",
        user_transaction: username,
        password: "",
        est_id: "",
        groups_add: [],
        groups_del: [],
        id: ""
    });

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await axios.get(`${server_backend}/Users/select?id=${onUserID}`, headers);
                if (response.data.RES_CODE === "00") {
                    console.log("Unexpected error, please check")
                    setCurrentUserGroups(response.data.RES_RESULT[0].groups
                    )
                    const data = response.data.RES_RESULT[0];
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setFormData({
                        name: data.name,
                        lastname: data.lastname,
                        email: data.email,
                        phone: data.phone,
                        dni: data.dni,
                        designation: data.designation,
                        department: data.department,
                        suc_id: data.suc_ID,
                        comment: data.comment,
                        lock: data.lock,
                        user_transaction: username,
                        password: data.password,
                        est_id: data.est_ID,
                        id: onUserID
                    });
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };
        fetchUser();
    }, [onUserID, username]);

    useEffect(() => {
        const getBranchs = async () => {
            try {
                const response = await axios.get(`${server_backend}/branchs/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setBranchList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };
        getBranchs();
    }, []);

    useEffect(() => {

        const getGroups = async () => {

            try {

                const response = await axios.get(`${server_backend}/groups/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setGroupList(response.data.RES_RESULT);
                }

            } catch (error) {
                console.log("Unexpected error, please check")
            }

        }
        getGroups()

    }, [0]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            return;
        }

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.post(`${server_backend}/Users/update`, formData, headers);
                    setLoading(true);
                    if (response.data.RES_CODE === "00") {

                        Swal.fire({
                            icon: 'success',
                            title: 'Updated Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        onClose();
                        getUsers();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'User already exists, please try another name',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }

                } catch (error) {
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    //identify and mark the checkboxes that belong to the user
    useEffect(() => {
        if (CurrentUserGroups && GroupList.length > 0) {
            const initialCheckedGroups = GroupList.map(group => ({
                ...group,
                isChecked: CurrentUserGroups.some(userGroup => userGroup.grp_ID === group.grp_ID)
            }));
            setCheckedGroups(initialCheckedGroups);
        } else {
            const initialCheckedGroups = GroupList.map(group => ({
                ...group,
                isChecked: false
            }));
            setCheckedGroups(initialCheckedGroups);
        }
    }, [GroupList, CurrentUserGroups]);



    const handleCheckboxChange = (grp_ID) => {
        setCheckedGroups(prevState =>
            prevState.map(group => {
                if (group.grp_ID === grp_ID) {
                    const isChecked = !group.isChecked;

                    //handle added and eliminated groups
                    if (isChecked) {
                        if (removedGroups.includes(grp_ID)) {
                            setRemovedGroups(removedGroups.filter(id => id !== grp_ID));
                        } else {
                            setAddedGroups([...addedGroups, grp_ID]);
                        }
                    } else {
                        if (addedGroups.includes(grp_ID)) {
                            setAddedGroups(addedGroups.filter(id => id !== grp_ID));
                        } else {
                            setRemovedGroups([...removedGroups, grp_ID]);
                        }
                    }

                    return { ...group, isChecked };
                }
                return group;
            })
        );
    };

    useEffect(() => {
        const currentGroupIDs = CurrentUserGroups ? CurrentUserGroups.map(group => group.grp_ID) : [];
        const updatedGroupsAdd = [...new Set([...currentGroupIDs.filter(id => !removedGroups.includes(id)), ...addedGroups])];

        setFormData(prevFormData => ({
            ...prevFormData,
            groups_add: updatedGroupsAdd.join(','),
            groups_del: removedGroups.join(',')
        }));
    }, [addedGroups, removedGroups, CurrentUserGroups]);

    const validateForm = () => {
        const newErrors = {};

        if (!formData.username) newErrors.username = 'Username is required';
        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        if (!formData.password) newErrors.password = 'Password is required';
        if (!formData.confirmPassword) newErrors.confirmPassword = 'Confirm Password is required';
        if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
        if (formData.groups_add.length === 0) newErrors.groups_add = 'At least one User Group must be selected';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <div className="row">
            <div className="card">

                <div className="card-header align-items-center d-flex">
                    <div className="col-md-12">
                        <div className="text-end">
                            <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Alert',
                                    text: "Are you sure you want to discard these changes?",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept',
                                    cancelButtonText: "Cancel"
                                }).then(async (result) => {
                                    if (result.isConfirmed) {
                                        onClose();
                                    }
                                }
                                )
                            }
                            }>Discard Change</Link>
                            <Link to="#" onClick={handleUpdate} className="btn btn-primary">
                                {loading ? "Loading..." : "Update"}
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleUpdate}>
                        <div className="row">
                            {/*Personal Information */}
                            <div className="col-md-12 mb-3">
                                <label htmlFor="name" className="form-label">Username</label>
                                <span className="text-danger" style={{ marginLeft: "5px" }}>*</span>
                                <input
                                    type="text"
                                    className={`form-control ${errors.id ? 'is-invalid' : ''}`}
                                    placeholder="Enter username"
                                    name="id"
                                    value={formData.id}
                                    onChange={handleChange}
                                    disabled
                                />
                                {errors.id && <div className="invalid-feedback">{errors.id}</div>}
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <span className="text-danger" style={{ marginLeft: "5px" }}>*</span>
                                <input
                                    type="text"
                                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                    placeholder="Enter your name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}

                                />
                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="lastname" className="form-label">Lastname</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your lastname"
                                    name="lastname"
                                    value={formData.lastname}
                                    onChange={handleChange}

                                />
                            </div>
                         {/*   <div className="col-md-6 mb-3">
                                <label htmlFor="dni" className="form-label">DNI</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your DNI"
                                    name="dni"
                                    value={formData.dni}
onChange={handleChange}
                                />
                            </div> */}

                            <div className="col-md-6 mb-3">
                                <label htmlFor="phone" className="form-label">Phone</label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    placeholder="Enter phone number"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <label htmlFor="email" className="form-label">Email</label>
                                <span className="text-danger" style={{ marginLeft: "5px" }}>*</span>
                                <input
                                    type="email"
                                    className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                    placeholder="Enter your email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                            </div>

                            {/*Job Information */}
                            <div className="col-md-6 mb-3">
                                <label htmlFor="designation" className="form-label">Designation</label>

                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Designation"
                                    name="designation"
                                    value={formData.designation}
                                    onChange={handleChange}
                                />

                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="department" className="form-label">Department</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your department"
                                    name="department"
                                    value={formData.department}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="password" className="form-label">Password</label>
                                <input
                                    type="password"
                                    className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                    placeholder="Enter new password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                                {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label htmlFor="suc_id" className="form-label">Branch</label>
                                <select
                                    className="form-control custom-select-style"
                                    name="suc_id"
                                    value={formData.suc_id}
                                    onChange={handleChange}
                                >
                                    {BranchList.map((branch) => (
                                        <option key={branch.suc_ID} value={branch.suc_ID}>
                                            {branch.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {/*Status */}
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="user_transaction" className="form-label">Status</label>
                                    <select
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                        name="est_id"
                                        value={formData.est_id}
                                        onChange={handleChange}
                                    >
                                        {formData.est_id === 1 ? (
                                            <>
                                                <option value="1">Activated</option>
                                                <option value="2">Disabled</option>
                                            </>
                                        ) : (
                                            <>
                                                <option value="2">Disabled</option>
                                                <option value="1">Activated</option>
                                            </>
                                        )}

                                    </select>

                                </div>

                            </div>

                            <div className="col-md-6 mb-3 ">
                                <br />  <br />
                                <div className="form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="lock"
                                        name="lock"
                                        checked={formData.lock === 1}
                                        onChange={(e) => handleChange({
                                            target: { name: 'lock', value: e.target.checked ? "1" : "0" }
                                        })}
                                    />
                                    <label className="form-check-label" htmlFor="lock">
                                        {formData.lock === "1" ? "Locked" : "Lock Status"}
                                    </label>
                                </div>
                            </div>

                            {/*Additional Information */}
                            <div className="col-12 mb-3">
                                <label htmlFor="comment" className="form-label">Comment</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter comment"
                                    name="comment"
                                    value={formData.comment}
                                    onChange={handleChange}
                                ></textarea>
                            </div>

                            <h4 className='p-3'>Users Group</h4>
                            <div className="col-md-12 mb-3 p-4">
                                <div className="row">
                                    {checkedGroups.map((group, index) => (
                                        <div className={`col-md-3 form-check mb-3`} key={group.grp_ID}>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={group.name}
                                                checked={group.isChecked}
                                                onChange={() => handleCheckboxChange(group.grp_ID)}
                                            />
                                            {errors.groups_add && <div className="text-danger">{errors.groups_add}</div>}
                                            <label className="form-check-label" htmlFor={group.name}>
                                                {group.name}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/*User Info */}
                            <h4 className='p-3'>Other information</h4>
                            <div className="col-6 mb-3">
                                <label htmlFor="date_created" className="form-label">Date Created</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={vAdminformat.FormatDate(dateCreated)}
                                    disabled
                                />
                            </div>
                            <div className="col-6  mb-3">
                                <label htmlFor="user_transaction" className="form-label">User Created</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.user_transaction}
                                    disabled
                                />
                            </div>

                            <div className="col-6  mb-3">
                                <label htmlFor="date_modify" className="form-label">Date Modified</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={dateModify && vAdminformat.FormatDate(dateModify)}
                                    disabled
                                />
                            </div>
                            <div className="col-6  mb-3">
                                <label htmlFor="user_created" className="form-label">User Modified</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={userModify}
                                    disabled
                                />
                            </div>


                            <div className="card-header align-items-center d-flex">
                                <div className="col-md-12">
                                    <div className="text-end">
                                        <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                            Swal.fire({
                                                icon: 'warning',
                                                title: 'Alert',
                                                text: "Are you sure you want to discard these changes?",
                                                showCancelButton: true,
                                                confirmButtonText: 'Accept',
                                                cancelButtonText: "Cancel"
                                            }).then(async (result) => {
                                                if (result.isConfirmed) {
                                                    onClose();
                                                }
                                            }
                                            )
                                        }
                                        }>Discard Change</Link>
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading ? 'Loading...' : 'Update'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default UpdateUser;
